var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('tbody',{staticClass:"table-loader-skeleton"},_vm._l((_vm.rows),function(row){return _c('tr',[_c('td',{attrs:{"colspan":_vm.cols}},[_c('div',{staticClass:"line"})])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }